import { Global } from '@emotion/core';
import { ThemeProvider } from 'emotion-theming';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import SessionTimeout from './hocs/SessionTimeout';
import Pages from './pages';
import { store } from './redux';
import { styles, Theme } from './styles';

const persistor = persistStore(store);

function App() {
  return (
    <Provider store={store}>
      <Global styles={styles} />
      <ThemeProvider theme={Theme}>
        <PersistGate loading={null} persistor={persistor}>
          <SessionTimeout>
            <Router>
              <LastLocationProvider>
                <Pages />
              </LastLocationProvider>
            </Router>
          </SessionTimeout>
        </PersistGate>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
